<template>
  <div class="page-business-consulting-add container">
    <div class="container-flex list-content">
      <div class="form-item">
        <div class="form-label">联系手机</div>
        <div class="form-input-box">
          <input
            :disabled="disabled"
            class="form-input"
            placeholder="联系手机"
            v-model="form.contactPhone"
            maxlength="11"
            type="number"
          />
        </div>
      </div>
      <div class="form-item">
        <div class="form-label">业务类型</div>
        <div class="form-input-box" @click="openModelShow">
          <div class="form-input-flex">{{ consultTypeName }}</div>
          <div class="v-center right-text" v-if="!disabled">
            <img
              class="right-icon"
              src="../../assets/image/my-cell-icon-right.png"
            />
          </div>
        </div>
      </div>

      <div class="form-item">
        <div class="form-label">合作内容</div>
        <div class="form-input-box address-details">
          <textarea
            v-if="!disabled"
            class="form-textarea"
            placeholder="请输入，限50字"
            v-model="form.content"
            maxlength="50"
          ></textarea>
          <div v-else>{{ form.content }}</div>
        </div>
      </div>
    </div>
    <div class="add-btn-box" v-if="!disabled">
      <pi-button type="primary" :loading="loading" block @click="addClick"
        >提交保存</pi-button
      >
    </div>
    <van-popup v-model="modelShow" position="bottom">
      <van-picker
        value-key="i18nItemValue"
        @cancel="modelShow = false"
        @confirm="bindMultiPickerChange"
        show-toolbar
        title="请选择类型"
        :columns="multiArray"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  addConsult,
  getUserBaseInfo,
  getDictInfoList,
} from "../../common/api/index";
import { Picker, Popup } from "vant";
export default {
  name: "business-consulting-add",
  components: {
    [Picker.name]: Picker,
    [Popup.name]: Popup,
  },
  data() {
    return {
      loading: false,
      form: {
        fullName: "",
        phoneNo: "",
        contactPhone: "",
        consultType: "",
        content: "",
      },
      consultTypeName: "请选择类型",
      modelShow: false,
      multiArray: [
        // 第一列
        {
          values: [
            // { name: "广东省", value: 1 },
            // { name: "广西省", value: 2 },
          ],
          defaultIndex: 0,
        },
      ],
      disabled: false,
    };
  },
  methods: {
    async addClick() {
      if (this.form.contactPhone == "") {
        this.$toast("请输入手机号码");
      } else if (this.form.consultType == "") {
        this.$toast("请选择类型");
      } else if (this.form.content == "") {
        this.$toast("请输入内容");
      } else {
        this.loading = true;
        let ret = await addConsult(this.form);
        if (ret.status === 0) {
          this.$toast("新增成功");
          this.$common.goBack();
        }
        this.loading = false;
      }
    },
    bindMultiPickerChange: function (val) {
      this.consultTypeName = val[0].i18nItemValue;
      this.form.consultType = val[0].itemKey;
      this.modelShow = false;
    },
    openModelShow() {
      if (!this.disabled) {
        this.modelShow = true;
      }
    },
    async getUserBaseInfo() {
      let ret = await getUserBaseInfo(null);
      if (ret.status === this.$config.ajaxStatus) {
        let userObject = ret.data[0];
        this.form.fullName = userObject.userName;
        this.form.phoneNo = userObject.phoneNo;
        this.form.contactPhone = userObject.phoneNo + '';
      }
    },
    async getDictInfoList() {
      let ret = await getDictInfoList(
        {
          typeIdList: "12492",
        },
        true
      );
      if (ret.status === 0) {
        let data = ret.data;
        if (data.length > 0) {
          this.multiArray[0].values = data;
        }
      }
    },
  },
  mounted() {
    this.getDictInfoList();
    this.getUserBaseInfo();
    let businessConsulting = this.$common.get("businessConsulting");
    if (businessConsulting) {
      this.form = Object.assign(this.form, businessConsulting);
      this.consultTypeName = businessConsulting.consultTypeDesc
      this.disabled = true;
      document.title= '咨询详情';
    }
  },
};
</script>

<style lang="less">
@import "../../assets/less/old/var.less";
.page-business-consulting-add {
  .list-content {
    padding: 0.2rem;
    position: relative;
  }
  .form-item {
    display: flex;
    margin-top: 0.2rem;
    font-size: 0.28rem;
    line-height: 0.4rem;
  }
  .form-item:first-child {
    margin-top: 0;
  }
  .form-label {
    width: 1.46rem;
    color: #000000;
    padding: 0.27rem 0;
  }
  .form-input-box {
    display: flex;
    flex: 1;
    background: #fafafa;
    border-radius: 0.12px;
    height: 0.9rem;
    padding: 0.27rem 0.2rem;
    box-sizing: border-box;
  }
  .form-input-box.address-details {
    min-height: 3rem;
    word-break:break-all
  }
  .form-input-flex {
    flex: 1;
  }
  .form-input,
  .form-textarea {
    width: 100%;
    background: transparent;
    font-size: 0.28rem;
    line-height: 0.4rem;
    color: #000000;
  }
  .form-textarea {
    height: 1.8rem;
  }
  .right-icon {
    width: 0.12rem;
    height: 0.21rem;
  }
  .address-right-icon {
    width: 0.32rem;
    height: 0.39rem;
  }
  .add-btn-box {
    padding: 0.2rem;
  }
}
</style>
